import React, { FC } from 'react'
import ProductsSlider from '@components/ProductsSlider'
import { Article_article } from '@graphql/__generated__/Article'
import { useQuery } from 'urql'
import { ARTICLES } from '@graphql/articles'
import { Articles, ArticlesVariables } from '@graphql/__generated__/Articles'
import { ArticlesFilterInput } from '@globalTypes'
import { useLocalization } from '@components/Localization'

type Props = {
  article: Article_article
}

// Horloges
// 1. Zelfde "Gender"
// 2. Zelfde "Collection_serie" (max 2)
// 3. Zelfde prijsklasse (max €200,- verschil bijvoorbeeld)
// 4. Zelfde "Dolor Dial"
// 5. Zelfde "Material Band"
// Juwelen
// Vergelijkbare juwelen parameters; in de juiste volgorde:
// 1. Zelfde "Type Jewel"
// 2. Zelfde "Collection_serie" (max 2)
// 3. Zelfde prijsklasse (max €200,- verschil bijvoorbeeld)
// 4. Zelfde "Material"

const RelatedProducts: FC<Props> = ({ article }) => {
  // console.log(article)
  let filters: ArticlesFilterInput = {
    attributeFilters: [],
    collections: []
  }
  if (article.articleType === 'Horloge') {
    const gender = article.articleAttributes.find(i => i.attributeOriginalName === 'Gender')
    if (gender) {
      filters.attributeFilters.push({
        attributeID: gender.attributeID,
        attributeValueID: [gender.attributeValueID]
      })
    }

    const pricing = article.articleAttributes.find(i => i.attributeOriginalName === 'priceCategory')
    if (pricing) {
      filters.attributeFilters.push({
        attributeID: pricing.attributeID,
        attributeValueID: [pricing.attributeValueID]
      })
    }

    const dial = article.articleAttributes.find(i => i.attributeOriginalName === 'Color Dial')
    if (dial) {
      filters.attributeFilters.push({
        attributeID: dial.attributeID,
        attributeValueID: [dial.attributeValueID]
      })
    }

    const strap = article.articleAttributes.find(i => i.attributeOriginalName === 'Material Strap')
    if (strap) {
      filters.attributeFilters.push({
        attributeID: strap.attributeID,
        attributeValueID: [strap.attributeValueID]
      })
    }

    if (article.collectionNumber) {
      filters.collections = [article.collectionNumber]
    }
  } else if (article.articleType === 'Juweel') {
    filters.collections = [2]

    const pricing = article.articleAttributes.find(i => i.attributeOriginalName === 'priceCategory')
    if (pricing) {
      filters.attributeFilters.push({
        attributeID: pricing.attributeID,
        attributeValueID: [pricing.attributeValueID]
      })
    }

    const material = article.articleAttributes.find(
      i => i.attributeOriginalName === 'Material Strap'
    )
    if (material) {
      filters.attributeFilters.push({
        attributeID: material.attributeID,
        attributeValueID: [material.attributeValueID]
      })
    }

    if (article.collectionNumber) {
      filters.collections = [article.collectionNumber]
    }
  }

  const { lang } = useLocalization()
  const [{ fetching, data }] = useQuery<Articles, ArticlesVariables>({
    query: ARTICLES,
    variables: {
      filters,
      pagination: {
        limit: 10
      }
    }
  })

  const articles = data?.articles?.items || []
  return (
    <ProductsSlider
      isLoading={fetching}
      articles={articles.filter(a => a.id !== article.id)}
      title={lang === 'nl' ? 'Vergelijkbare producten' : 'Related products'}
    />
  )
}

export default RelatedProducts
